export default __webpack_public_path__ + "static/media/donati-banner-desktop.c27b7178.jpg";